import { render, staticRenderFns } from "./DownloadReleaseLetter.vue?vue&type=template&id=1be29917"
import script from "./DownloadReleaseLetter.vue?vue&type=script&lang=js"
export * from "./DownloadReleaseLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports